"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEditorialCategoryOrPage = void 0;
var _fetching = require("@ori/fetching");
var _queriesNet = require("../queries-net");
var _utils = require("../utils");
/**
 * Fetch function that fetches data for editorial category or landing page from GraphQL.
 */ const getEditorialCategoryOrPage = async (param)=>{
    let { graphQlUrl, headers, pageId, previewMode, landingPageId, includeRoot, includeThemeItems } = param;
    const data = await (0, _fetching.fetchGraphql)({
        query: _queriesNet.editorialCategoryOrPageQuery,
        url: graphQlUrl,
        variables: {
            pageId,
            landingPageId,
            includeThemeItems,
            includeRoot
        },
        headers: {
            ...headers,
            [_fetching.PREVIEW_MODE]: previewMode !== null && previewMode !== void 0 ? previewMode : false
        },
        ...previewMode ? {
            timeout: 30000
        } : null
    });
    var _data_application;
    const { editorialLandingPage, editorialPage, rootEditorialLandingPage } = (_data_application = data.application) !== null && _data_application !== void 0 ? _data_application : {};
    var _editorialLandingPage_landingPageId;
    return {
        application: {
            editorialLandingPage: {
                ...editorialLandingPage,
                landingPageId: (_editorialLandingPage_landingPageId = editorialLandingPage === null || editorialLandingPage === void 0 ? void 0 : editorialLandingPage.landingPageId) !== null && _editorialLandingPage_landingPageId !== void 0 ? _editorialLandingPage_landingPageId : '',
                themeItems: (0, _utils.filterOutCurrentCategory)({
                    // themeItems are returned with start slash in landingPageId attribute
                    pageId: pageId.startsWith('/') ? pageId : "/".concat(pageId),
                    // Use rootEditorialLandingPage for non-landing pages
                    categories: landingPageId ? rootEditorialLandingPage === null || rootEditorialLandingPage === void 0 ? void 0 : rootEditorialLandingPage.themeItems : editorialLandingPage === null || editorialLandingPage === void 0 ? void 0 : editorialLandingPage.themeItems
                })
            },
            editorialPage
        }
    };
};
exports.getEditorialCategoryOrPage = getEditorialCategoryOrPage;
